import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import DataSelect from "../../../../../../ui/DataSelect";
import Grid from "@material-ui/core/Grid";
import { getOrganizations, getDepartments } from "../../../store/actions";

const styles = () => ({
  root: {
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  block: {
    margin: "35px 0 15px 0"
  },
  checkbox: {
    "& > .MuiCheckbox-colorPrimary.Mui-checked": {
      color: "rgba(0, 127, 189, 0.7);"
    }
  },
  label: {
    fontSize: 10
  },
  customFileUpload:{
    border: "1px solid #596E79",
    borderRadius: "5px",
    display: "inline-block",
    padding: 10,
    cursor: "pointer",
    marginTop: 15,
    color: "#596E79",
    fontSize: 16,
    textTransform: "uppercase",
    "&:hover" : {
      color: "#D0101B",
      borderColor: "#D0101B"
    },
    "& input[type='file']": {
        display: "none"
    }
  },
  filePreview : {
  marginTop: 15,
  marginLeft: 15,
  display: "inline-block",
  fontSize: 16
},
fileRemoveCross : {
  display: "inline-block",
  marginLeft: 10,
  cursor: "pointer"
}
});

const initialInfo = {
  orgId : null,
  depId : null,
  file : null
}

const ImportForm = ({
  classes,
  getOrganizations,
  getDepartments,
  organizations,
  departments,
  disabled,
  onFormChange
}) => {
  const [data, setData] = React.useState(initialInfo);
  const {orgId, depId, file } = data;

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  const handleFileChange = e => {
        let file = null;
        if (e.target.files != null && e.target.files.length > 0) {
            file = e.target.files[0];
        }
        onChange("file", file);
    };

  const handleFileRemove = () => {
      onChange("file", null);
  };

  React.useEffect(() => {
    getOrganizations();
  }, []);

  React.useEffect(() => {
    if (orgId) {
      getDepartments(orgId);
    }
  }, [orgId]);

  return (
    <div className={classes.root}>
          <Grid container spacing={1}>
              <Grid item xs={12}>
                {organizations && <DataSelect
                  value={orgId}
                  onChange={value => onChange("orgId", value.id)}
                  label="Организация"
                  dataSource={organizations}
                  disabled={disabled}
                />}
              </Grid>
              <Grid item xs={12}>
                {departments && <DataSelect
                  value={depId}
                  onChange={value => onChange("depId", value.id)}
                  label="Подразделение"
                  dataSource={departments}
                  disabled={disabled}
                />}
              </Grid>
              <Grid item xs={12}>
                <label className={classes.customFileUpload}>
                    <input name="scanfile" type="file" accept=".csv" onChange={handleFileChange}/>
                    Выбрать файл (*.csv)
                </label>
                  {file && <div className={classes.filePreview}>
                      {file.name}
                      <span title="Удалить файл" className={classes.fileRemoveCross}
                            onClick={handleFileRemove}>
                          <svg width="9" height="9" viewBox="0 0 9 9" fill="none"
                               xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.4 0.8225L7.554 0L4.2 3.26083L0.846 0L0 0.8225L3.354 4.08333L0 7.34417L0.846 8.16667L4.2 4.90583L7.554 8.16667L8.4 7.34417L5.046 4.08333L8.4 0.8225Z"
                                  fill="#D0101B"/>
                          </svg>
                      </span>
                  </div>
                }
              </Grid>
          </Grid>
    </div>
  );
};

const mapStateToProps = state => ({
  isFetchingOrganizations: state.persons.isFetchingOrganizations,
  organizations: state.persons.organizations,
  isFetchingDepartments: state.persons.isFetchingDepartments,
  departments: state.persons.departments
});

const mapDispatchToProps = dispatch => ({
  getOrganizations: () => dispatch(getOrganizations()),
  getDepartments: (id) => dispatch(getDepartments(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ImportForm));
